import { inject, Service } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '@services/toast';

@Service()
export class ErrorMessageService {
  private readonly toastService = inject(ToastService);
  private readonly translate = inject(TranslateService);

  async displayErrorMessage(header: string, message: string): Promise<void> {
    const fullMessage = header ? `${header}: ${message}` : message;
    await this.toastService.showErrorAsync(fullMessage);
  }

  async displayValidationErrorMessage(message: string): Promise<void> {
    await this.displayErrorMessage(this.translate.instant('general.error'), message);
  }

  async displayGlobalErrorMessage(): Promise<void> {
    await this.displayErrorMessage(
      this.translate.instant('general.error'),
      this.translate.instant('general.unexpectedError'),
    );
  }
}
